import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
  ExchangeConfigActionEnum, IPostExchangeConfigAction,
} from '.';
import {
    ConfigurationManagementEnum,
    ExchangeConfigService, IExchangeConfig,
} from '../../services';
import { FetchExchangeConfigFailedAction, FetchExchangeConfigSuccessAction, PostExchangeConfigFailedAction, PostExchangeConfigSuccessAction } from './ActionCreator';
import { toast } from 'react-toastify';

const exchangeConfigService = new ExchangeConfigService();

export const fetchExchangeConfigEpic = (action$: any) =>
    action$.pipe(
        ofType(ExchangeConfigActionEnum.FetchExchangeConfig),
        switchMap(() => {
            const exchangeConfigs = exchangeConfigService.getAllExchangeConfig();
            return exchangeConfigs;
        }),
        map((response: IExchangeConfig[]) => {
            return FetchExchangeConfigSuccessAction(response);
    }),
    catchError((x) => {
      console.error(x);
      return of(FetchExchangeConfigFailedAction(ConfigurationManagementEnum.UnableToGetExchangeConfig));
    })
  );
export const postExchangeConfigUpdaactionEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(ExchangeConfigActionEnum.PostExchangeConfig),
    withLatestFrom(state$),
    switchMap(([action]: [IPostExchangeConfigAction]) => {
      if (action?.state?.exchangeConfig) {

        const response = exchangeConfigService.postExchangeConfigUpdate(action.state.exchangeConfig);
        return response;
      }
      else {
        toast.error(ConfigurationManagementEnum.UnableToPostExchangeConfig, { autoClose: 3000, draggable: true, position: "bottom-right" });
        return of(PostExchangeConfigFailedAction(ConfigurationManagementEnum.UnableToPostExchangeConfig));
      }
    }),
    map((response: boolean) => {
      toast.success(ConfigurationManagementEnum.ExchangeConfigPostSuccess, { autoClose: 3000, draggable: true, position: "bottom-right" });
      return PostExchangeConfigSuccessAction();
    }),
    catchError((x) => {
      console.error(x);
      toast.error(ConfigurationManagementEnum.UnableToPostExchangeConfig, { autoClose: 3000, draggable: true, position: "bottom-right" });
      return of(PostExchangeConfigFailedAction(ConfigurationManagementEnum.UnableToPostExchangeConfig));
    })
  );
